import { maskItem } from '@/components/DashboardCard/utils/maskItem';
import PopoverComponent from '@/components_v2/PopoverComponent';
import React from 'react';

import { CellTypeProps } from '../../interfaces';
import { CellItem, ToolTip, ValueArea } from './styles';

const Image: React.FC<CellTypeProps> = ({
  color,
  backgroundColor,
  textAlign,
  children,
  extraValue,
  value,
  custom_tooltip,
  fontWeight,
  maskValue,
  fontSize,
  url_image,
  imageWidth,
}) => {
  const parsedValue = maskValue ? maskItem(maskValue, value) : value;
  const customTooltip = maskValue
    ? maskItem(maskValue, custom_tooltip)
    : custom_tooltip;

  const renderCellImage = () => (
    <CellItem
      fontWeight={fontWeight}
      backgroundColor={backgroundColor || 'transparent'}
      color={color || '#333'}
    >
      <ValueArea
        textAlign={textAlign || 'right'}
        backgroundColor={backgroundColor}
        fontSize={fontSize}
      >
        {url_image && (
          <div
            style={{
              height: '100%',
              width: imageWidth || '100%',
              minWidth: 50,
            }}
          >
            <img
              src={url_image}
              alt=""
              style={{
                height: '100%',
                padding: 5,
                objectFit: 'cover',
              }}
            />
          </div>
        )}
        <span
          style={{
            whiteSpace: 'nowrap',
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
          }}
        >
          {parsedValue}
          {children !== '-' && extraValue}
        </span>
      </ValueArea>
    </CellItem>
  );

  return (
    <PopoverComponent
      placement="top"
      trigger={renderCellImage()}
      disabled={!value || value.toString().length < 5}
    >
      <ToolTip>
        {custom_tooltip ? customTooltip : parsedValue}
        {children !== '-' && extraValue}
      </ToolTip>
    </PopoverComponent>
  );
};

export default Image;
